import styles from '../styles/WelcomeCard.module.css'
import {FaTwitter, FaDiscord, FaTelegram} from "react-icons/fa"
export const Social = () => {
    return (
        <div>
            <div className={styles.social}>
                <div className={styles.icons}>
                    <FaTelegram onClick={() => { console.log("clicked")}} className={styles.icon1}/>
                    <FaDiscord onClick={() => { console.log("clicked")}} className={styles.icon}/>
                    <FaTwitter onClick={() => { console.log("clicked")}} className={styles.icon}/>
                </div> 
            </div>
        </div>
    )
}